import { Button, Select } from '@fluentui/react-components';
import { useCallback } from 'react';

import {
  DATASET_ACCESS_FILTERS,
  DATASET_DATA_TYPES,
} from '../../../constants/index.js';

import type {
  DatasetDataType,
  DatasetFilterProps,
} from './DatasetFilter.interface.js';
import { useStyles } from './DatasetFilter.style.js';

export function DatasetFilter({
  dataType,
  onDataTypeChange,
  accessFilter,
  onAccessFilterChange,
}: DatasetFilterProps) {
  const styles = useStyles();

  const handleDataTypeChange = useCallback(
    (_e: React.ChangeEvent<HTMLSelectElement>, data: { value: string }) => {
      onDataTypeChange(data.value as DatasetDataType);
    },
    [onDataTypeChange],
  );

  return (
    <div className={styles.root} role="group" aria-label="Dataset filters">
      {/* TYPE filter */}
      <div className={styles.filterGroup}>
        <span className={styles.filterLabel}>Type</span>
        <Select
          className={styles.select}
          size="small"
          value={dataType}
          onChange={handleDataTypeChange}
          aria-label="Filter by data type"
        >
          {DATASET_DATA_TYPES.map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </Select>
      </div>

      {/* ACCESS filter */}
      <div className={styles.filterGroup}>
        <span className={styles.filterLabel}>Access</span>
        <div
          className={styles.accessToggle}
          role="group"
          aria-label="Filter by access level"
        >
          {DATASET_ACCESS_FILTERS.map((level) => (
            <Button
              key={level}
              appearance="transparent"
              size="small"
              className={
                accessFilter === level
                  ? styles.accessButtonActive
                  : styles.accessButton
              }
              onClick={() => {
                onAccessFilterChange(level);
              }}
              aria-pressed={accessFilter === level}
            >
              {level}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
}
